import { styled } from '@mui/material';
import { coreThemeColors } from '@youscience/theme';
import { CoreBox } from '@youscience/core';

import ActionButton from '@components/ActionButton';

export const StyledContentSchoolList = styled(CoreBox)(() => ({
  display: 'flex',
  flex: 'auto',
  padding: '2rem 0rem',
  flexDirection: 'column',
  gap: '1rem',
}));

export const StyledContentSchoolListHeader = styled(CoreBox)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'row',
  gap: '1rem',
  justifyContent: 'space-between',
  [theme.breakpoints.down('md')]: {
    flexDirection: 'column',
    gap: '0.5rem',
  },
}));

export const StyledContentSchoolListHeaderButton = styled(ActionButton)(({ variant }) => ({
  flex: 'none',
  padding: '0.5rem 1rem',
  borderRadius: '9999px',
  border: `1px solid ${coreThemeColors.secondary.main}`,
  backgroundColor: variant === 'outlined' ? coreThemeColors.common.white : coreThemeColors.secondary.main,

  '& > svg:first-of-type': {
    marginRight: '0.75rem',
  },

  '&:hover': {
    backgroundColor:
      variant === 'outlined' ? coreThemeColors.secondary.outlinedHoverBackground : coreThemeColors.secondary.dark,
  },
}));

export const StyledContentSchoolListItems = styled(CoreBox)(() => ({
  flex: 'auto',
}));

export const StyledContentSchoolListItem = styled(CoreBox)(({ theme }) => ({
  display: 'flex',
  flex: 'auto',
  padding: '1.5rem 1rem',
  gap: '1.5rem',
  borderRadius: '0.5rem',
  border: `1px solid ${coreThemeColors.grey[300]}`,
  background: theme.palette.background.paper,
}));
